/* Shared between the four tabs. */

export const RATING_LABELS = {
    1: "Needs improvement",
    2: "Below expectations",
    3: "Meets expectations",
    4: "Exceeds expectations",
    5: "Outstanding",
};

export const STATUS = {
    pending: { label: "Self assessment due", tone: "wh-pill-warn" },
    self_submitted: { label: "With your manager", tone: "wh-pill" },
    completed: { label: "Completed", tone: "wh-pill-good" },
};

export const CYCLE_STATUS = {
    draft: { label: "Draft", tone: "wh-pill-quiet" },
    self: { label: "Self assessment open", tone: "wh-pill-warn" },
    manager: { label: "Manager assessment", tone: "wh-pill" },
    closed: { label: "Closed", tone: "wh-pill-quiet" },
};

/* Colour a score the way the pills elsewhere are coloured. */
export const scoreTone = (score) =>
    score >= 4 ? "wh-pill-good"
        : score >= 3 ? "wh-pill"
            : score > 0 ? "wh-pill-warn" : "wh-pill-quiet";

/* Group a flat item list back into the categories it came from, so the form
   reads the way the template was written. */
export const byCategory = (items = []) => {
    const groups = [];
    items.forEach((item, index) => {
        let group = groups.find((g) => g.name === item.category);
        if (!group) {
            group = { name: item.category, weight: item.categoryWeight, rows: [] };
            groups.push(group);
        }
        group.rows.push({ ...item, index });
    });
    return groups;
};

/* Self and manager averages per category, plus how far apart they are.
   The categories come from the review itself, so they match what the person
   was actually assessed against. */
export const compareByCategory = (items = []) =>
    byCategory(items).map((group) => {
        const avg = (field) => {
            const rated = group.rows.filter((r) => Number(r[field]) > 0);
            if (!rated.length) return 0;
            return Math.round((rated.reduce((t, r) => t + Number(r[field]), 0) / rated.length) * 100) / 100;
        };
        const self = avg("selfRating");
        const manager = avg("managerRating");
        return { ...group, self, manager, gap: Math.round((manager - self) * 100) / 100 };
    });

/* "0.4 above how you rated yourself" — the sentence a bare number does not
   say on its own. */
export const gapLabel = (gap) => {
    if (!gap) return "the same as you rated yourself";
    const size = Math.abs(gap).toFixed(2).replace(/\.?0+$/, "");
    return gap > 0
        ? `${size} above how you rated yourself`
        : `${size} below how you rated yourself`;
};

export const gapTone = (gap) =>
    gap > 0 ? "perf-gap-up" : gap < 0 ? "perf-gap-down" : "perf-gap-level";
